// FIXME: SDK instance should be created by app FLAVOR (bs.tizen, bs.orsay, etc).
// To try it for web, change /bs.tizen for /web
import SDK from "starzplay-sdk/dist/bs.ps4";
import { config } from "../config/config";
import localConfig from "../config/localConfig";

let sdk = null;
let sdkInstantiationPromise = null;

/**
 * Returns an instance of the sdk. This function is a singleton so it will always return the same instance once it's
 * created. If when calling this function there is no sdk instance yet, the function will return a promise that will
 * resolve with an instance created asynchronously. This is required because the sdk needs a config object to be
 * instantiated and the config object could be located remotely, so a network call might be needed.
 * @returns {Object|Promise}  An instance of the SDK is it's already created or a promise that will resolve to the SDK
 * instance.
 */
export const getSdk = () => {
  if (!sdk) {
    if (!sdkInstantiationPromise) {
      sdkInstantiationPromise = new Promise(async resolve => {
        const configuration = await config.get();
        configuration.sdk.environment = localConfig.environment;
        sdk = SDK(configuration.sdk);
        resolve(sdk);
      });
    }
    return sdkInstantiationPromise;
  }
  return sdk;
};
